import { HttpContextToken } from '@angular/common/http';

// Only the transfer request owns its error presentation.
export const ECONOMIC_TRANSFER_DIALOG = new HttpContextToken<boolean>(() => false);
